import { Link } from "react-router-dom";
import { Boxes, LogOut, User, Infinity as InfinityIcon } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const Header = () => {
  const { user, logout, setShowLogin } = useAuth();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary text-primary-foreground">
            <Boxes className="h-5 w-5" strokeWidth={2.2} />
          </div>
          <div className="leading-none">
            <div className="font-display text-lg font-black tracking-tight">
              GloGrid <span className="text-primary">Part Cost Estimate</span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
              Cost&nbsp;to&nbsp;Manufacture
            </div>
          </div>
        </Link>

        <div className="flex items-center gap-3 sm:gap-5">
          <a
            href="https://glogrid.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-glogrid-link"
            className="hidden font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary sm:block"
          >
            About GloGrid →
          </a>

          {user ? (
            <div className="flex items-center gap-3">
              <Link
                to="/rates"
                data-testid="rates-link"
                className="hidden font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary sm:block"
              >
                Rate Library
              </Link>
              {user.is_owner && (
                <Link
                  to="/admin"
                  data-testid="admin-link"
                  className="hidden font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground transition-colors hover:text-primary sm:block"
                >
                  Admin
                </Link>
              )}
              {user.unlimited ? (
                <span
                  data-testid="usage-indicator"
                  className="hidden items-center gap-1 rounded-sm bg-primary/10 px-2.5 py-1 font-mono text-[11px] uppercase tracking-wide text-primary sm:inline-flex"
                >
                  <InfinityIcon className="h-3.5 w-3.5" /> Unlimited
                </span>
              ) : (
                <span
                  data-testid="usage-indicator"
                  className="hidden items-center gap-1 rounded-sm bg-secondary px-2.5 py-1 font-mono text-[11px] uppercase tracking-wide text-secondary-foreground sm:inline-flex"
                >
                  {user.remaining} / {user.limit} free left
                </span>
              )}
              <div className="hidden items-center gap-1.5 font-mono text-xs text-muted-foreground md:flex">
                <User className="h-3.5 w-3.5" /> {user.email}
              </div>
              <button
                data-testid="logout-button"
                onClick={logout}
                className="flex h-8 w-8 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
                title="Sign out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          ) : (
            <Button
              data-testid="header-login-button"
              onClick={() => setShowLogin(true)}
              variant="outline"
              className="h-9 rounded-sm"
            >
              Sign in
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
